
import React from "react";
import DataGrid, { Paging, Column, Scrolling, MasterDetail, Selection } from 'devextreme-react/data-grid';
import { useTranslation } from 'react-i18next'

const TableQueue = (props) => {
  const { t } = useTranslation(['plan', 'common'])
  let { dataSource } = props // STATE
  let { onSelectionChanged, onEdit, height } = props // ACTION

  return (
    <DataGrid
      dataSource={dataSource}
      keyExpr="id"
      height={height}
      showBorders={true}
      allowColumnReordering={true}
      columnAutoWidth={true}
      hoverStateEnabled={true}
      onSelectionChanged={(e) => onSelectionChanged(e.selectedRowKeys)}
    >
      <Scrolling columnRenderingMode="virtual" />
      <Selection
        mode="multiple"
        selectAllMode="allPages"
        showCheckBoxesMode="always"
      />
      <Paging enabled={false} />
      <Column
        dataField="no"
        caption={t('number')}
        width={50}
        alignment="center"
      />
      <Column dataField="qno" caption={t('delivery_number')} />
      <Column dataField="po_no" caption="SO No." />
      <Column dataField="gq_no" caption="GQ No." />
      <Column dataField="cust_code" caption={t('customer_code')} />
      <Column dataField="cust_name" caption={t('customer_name')} />
      <Column dataField="shippoint_name" caption={t('origin')} />
      <Column dataField="shipto_name" caption={t('destination')} />
      <Column dataField="job_type_name" caption={t('job_type')} />
      <Column dataField="delivery_date" caption="วันที่ส่งสินค้า" />
      <Column dataField="job_date" caption={t('job_received_date')} />
      <Column dataField="center_name" caption={t('department')} />
      <Column dataField="shipment_type_name" caption={t('trip_type')} />
      <Column dataField="status_name" caption={t('status')} />
      <Column dataField="ref_order_no" caption="Ref Order No" />
      <Column dataField="track_no" caption="Track No" />
      <Column dataField="updated_by" caption={t('edit_by')} />
      <Column
        fixed={true}
        caption={t('edit')}
        type="buttons"
        alignment="center"
        width={50}
        cellRender={(e) => {
          let { status } = e.data
          if (status !== "99") {
            return <i
              className="fa fa-pencil-square-o cursor-pointer"
              onClick={() => {
                onEdit(e.row.data)
              }}
            />
          }
          else {
            return ""
          }
        }}
      />
      <MasterDetail
        enabled={true}
        component={DetailTemplate}
      />
    </DataGrid>
  )
}

const DetailTemplate = (props) => {
  let dataSource = props?.data?.data?.products

  return <React.Fragment>
    <div className="master-detail-caption">
      รายละเอียดสินค้า
    </div>
    <DataGrid
      dataSource={dataSource}
      showBorders={true}
      columnAutoWidth={true}
      width={600}
    >
      <Column dataField="product_code" caption="รหัสสินค้า" width={150} />
      <Column dataField="product_name" caption="ชื่อสินค้า" width={200} />
      <Column dataField="product_qty" caption="จำนวน" width={100} />
      <Column dataField="unit_name" caption="หน่วย" width={100} />

    </DataGrid>
  </React.Fragment>
}

export default TableQueue